import script from "./MyGocuButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MyGocuButton.vue?vue&type=script&setup=true&lang=js"

import "./MyGocuButton.vue?vue&type=style&index=0&id=2aaa45e4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aaa45e4"]])

export default __exports__